import React, { useRef, useState, useEffect } from 'react';
import {InputComponent ,FileUploadComponent } from '../custcomponents';
import { ToastContainer, toast } from 'react-toastify';
import { AxiosInstance } from '../utils';
type PosterCreatorProps = {
  templateUrl: string;
  eventcode: string;
};

const PosterCreator: React.FC<PosterCreatorProps> = ({ templateUrl, eventcode }) => {
  const [userDP, setUserDP] = useState<File | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserdetails] = useState(null as any);
  const [useremail, setUseremail] = useState('' as any);
  const placeholder = {
    x: 57,
    y: 347,
    size: 416,
  };

  const textplaceholder = {
    x: 800,
    y: 600,
    size: 416,
  };
  const designationplaceholder = {
    x: 750,
    y: 670,
    size: 416,
  };

  useEffect(() => {
    console.log('PosterCreator useEffect triggered with templateUrl:', templateUrl);
    if (!templateUrl ) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const templateImg = new Image();
    const dpImg = new Image();

    templateImg.crossOrigin = 'anonymous';
    dpImg.crossOrigin = 'anonymous';

    templateImg.onload = () => {
      canvas.width = templateImg.width;
      canvas.height = templateImg.height;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(templateImg, 0, 0);
      //NAME
      ctx.fillStyle = 'white'; // Text color
      ctx.font = 'bold 50px Arial'; // Font style
      ctx.textAlign = 'center'; // Horizontal alignment
      ctx.textBaseline = 'top';
      const text = userDetails.name;
      const textWidth = ctx.measureText(text).width;
      console.log("textWidth " + textWidth + " canvas.width " + canvas.width );
      // Compute the starting X so the text is centeredconso
      var additionalMargin = 0;
      if( textWidth>480)
      {
        additionalMargin=100;
      }
      const x =  ( (canvas.width    - textWidth) / 2)  + additionalMargin  ;
      const y = 550; // Adjust Y as needed
      console.log("x " + x + " y " + y );
      ctx.fillText(text.toUpperCase(),(canvas.width / 2)+50, y); // Text and position


      let tiitle = userDetails.title
      let companyname = userDetails.company
      const textWidthtitle = ctx.measureText(tiitle).width;
      // DESIGNATION
      var additionalMargintitle = 0;
      if( textWidthtitle>480)
      {
        additionalMargintitle=100;
      }
      console.log("textWidthtitle " + textWidthtitle + " canvas.width " + canvas.width );
      const xtitle =  ( (canvas.width    - textWidthtitle) / 2) +  (textWidthtitle>textWidth ? 80:0)   + additionalMargintitle  ;
      const ytitle = 630; // Adjust Y as needed
      ctx.fillStyle = 'white'; // Text color
      ctx.font = 'bold 36px Arial'; // Font style
      ctx.textAlign = 'center'; // Horizontal alignment
      ctx.textBaseline = 'top';
      ctx.fillText(tiitle.toUpperCase(),(canvas.width / 2)+50,ytitle); // Text and position

      const ycompanytitle = 680; // Adjust Y as needed
      ctx.fillStyle = 'white'; // Text color
      ctx.font = 'bold 36px Arial'; // Font style
      ctx.textAlign = 'center'; // Horizontal alignment
      ctx.textBaseline = 'top';
      ctx.fillText(companyname.toUpperCase(),(canvas.width / 2)+50,ycompanytitle); // Text and position

      if (userDP) {
        dpImg.onload = () => {
          ctx.save();
          ctx.beginPath();
          ctx.arc(
            placeholder.x + placeholder.size / 2,
            placeholder.y + placeholder.size / 2,
            placeholder.size / 2,
            0,
            Math.PI * 2
          );
          ctx.closePath();
          ctx.clip();

          ctx.drawImage(dpImg, placeholder.x, placeholder.y, placeholder.size, placeholder.size);
          ctx.restore();
        };

        dpImg.src = URL.createObjectURL(userDP);
      }
    };

    templateImg.src = templateUrl;
  }, [templateUrl, userDP, userDetails]);

  const handleDPChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setUserDP(e.target.files[0]);
    } else {
      setUserDP(null); // If file input is cleared
    }
  };

  const handleDownload = () => {
    const canvas = canvasRef.current;
    if (!canvas || !userDP) 
    {
      toast.error('Upload user photo.');
      return;
    }

    const dataURL = canvas.toDataURL('image/jpeg');
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = 'I-am-attending.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchUserDetails = async () =>{
   
    const { data: response } = await AxiosInstance.get('/api/getuserdetails?eventcode=' + eventcode + '&emailid=' + useremail );
    if (response.result != "Success") {
      setLoading(false);
      setUserdetails(null);
      setUserDP(null);
      toast.error('User Not found.');
      return;
  }
  setLoading(false);
  setUserdetails(response.data);

  }
  return (
    <>
  <section className="event-price-sec sec-padding" id="postercreator" data-scroll-index="5">
            <div className="container">
                <div className="sec-title">
                    <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-thumbs-up fa-stack-1x"></i></span></span>
                    <h3 className="wow fadeInRight" data-wow-duration="500ms">Poster Creator <small> / I am attending</small></h3>
                </div> {/* <!--sec-title end--> */}
                <div className="price-sec-details">

                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                <InputComponent custname="IdvName" custid="txtidvemail" onExternalBind={useremail} onExternalValue={setUseremail}  custplaceholder="Registered E-Mail" />
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="form-field text-center" >
                            <button type="button" className="btn-default" onClick={fetchUserDetails}>Fetch Details <i className="fa fa-arrow-circle-right"></i></button>
                        </div>
                </div>
                    </div>

{userDetails && <>
<form>
                    <fieldset className="form-group p-3">
                                <legend className="w-auto px-2 subheading">Poster Details</legend>

                    <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                    <canvas ref={canvasRef} style={{ border: '1px solid #ccc', marginTop: 20 , maxWidth: 800, maxHeight: 400 }} />
                    </div>
                    </div>
                    <div className="row pt-3">
                    <div className="col-lg-4 col-md-6 col-sm-6">
        <label>Upload Your DP: </label>
        
 <div className="form-field form-label-group-cust ">
        <input type="file" className="form-control-cust"  accept="image/*" onChange={handleDPChange} />
        </div>     

                      </div>
                    </div>
                      <div className="row  pt-3">
                    <div className="col-lg-4 col-md-6 col-sm-6">

<div className="form-field text-center" >
                            <button type="button" className="btn-default" onClick={handleDownload}>Download Poster <i className="fa fa-arrow-circle-right"></i></button>
                        </div>


                </div> {/* <!--price-sec-details end--> */}
            </div>
            </fieldset>
            </form>
            </>}
            </div>
            </div>
        </section>

        </>
  );
};

export default PosterCreator;
